import usePageParams from '@anm/hooks/usePageParams';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { pricingSelectors } from '../../../../store/modules/pricing';
import { userSelectors } from '../../../../store/modules/user';

const useSaleCoupon = () => {
  const [coupon, setCoupon] = useState('');
  const saleCoupon = useSelector(pricingSelectors.selectCurrentSaleCoupon);
  const isUserFree = !!useSelector(userSelectors.selectWaveFreeUser);

  useEffect(() => {
    isUserFree && setCoupon(saleCoupon || '');
  }, [saleCoupon]);

  return coupon;
};

const useCoupon = () => {
  const { coupon: couponParam } = usePageParams<{
    coupon: string | undefined;
  }>();
  const [coupon, setCoupon] = useState(couponParam || '');
  const saleCoupon = useSaleCoupon();

  useEffect(() => {
    setCoupon(couponParam || saleCoupon || '');
  }, [couponParam, saleCoupon]);

  return [coupon, setCoupon] as const;
};

export default useCoupon;
